module.exports = __webpack_public_path__ + "img/flag.a5f20e0a.png";